/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import {
  DropdownHeader,
  DropdownMenuItem,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import { useAudioSettings } from "./useAudioSettings";

export const AudioSection = () => {
  const { tracks, activeTrack, onTrackSelect } = useAudioSettings();

  const { t } = usePlayerTranslation();

  return (
    <DropdownMenuSection name="audio">
      <DropdownHeader navigateToSection="settings">
        {t("PLAYER_SETTINGS_AUDIO")}
      </DropdownHeader>
      <DropdownScrollableArea>
        {tracks.map((track) => {
          return (
            <DropdownMenuItem
              key={track.id}
              onItemSelect={() => onTrackSelect(track)}
              active={activeTrack && track.id === activeTrack.id}
              resetToDefaultSectionAfterSelect
              showActiveIcon
            >
              {track.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownScrollableArea>
    </DropdownMenuSection>
  );
};
